import { getPhone } from './getPhone';
import { buildAddress } from './buildAddress';

/**
 * Creates a department location object
 *
 * @param {ADDDepartment} department - Department data
 * @param {ADDDepartment} normalizedDepartment
 * Normalized department data with fallbacks
 * @param {WidgetLocation} defaultLocation - Default location for missing fields
 * @returns {WidgetLocation} Department location object
 */
export const createDepartmentLocation = (
	department,
	normalizedDepartment,
	defaultLocation
) => {
	const { address } = department;
	const phoneNumber = getPhone(normalizedDepartment);

	const deptPhones = phoneNumber
		? [{ number: phoneNumber, type: department.label || 'default' }]
		: [];

	return {
		address: buildAddress(normalizedDepartment),
		city: address.city || defaultLocation.city,
		country: address.country || defaultLocation.country,
		postalCode: address.postalCode || defaultLocation.postalCode,
		state: address.state || defaultLocation.state,
		type: 'department',
		hours: normalizedDepartment.hours,
		phones: deptPhones,
		timeZoneId: department.timeZoneId,
		email:
			normalizedDepartment.contactInformation.email1 ||
			normalizedDepartment.contactInformation.email2,
		departmentName: department.label || department.type || 'Department'
	};
};
